"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = FormIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils/utils");
function FormIcon({
  borderColor,
  innerColor,
  icon,
  width,
  height
}) {
  switch (icon) {
    default:
    case "disabled-checkbox":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "1.5",
        fill: "white",
        stroke: borderColor || _utils.colors["grey-3"].hex
      }));
    case "disabled-radio":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z",
        stroke: borderColor || _utils.colors["grey-3"].hex,
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4.10834 4.10834L15.8917 15.8917",
        stroke: borderColor || _utils.colors["grey-3"].hex,
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "selected-checkbox":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "1.5",
        fill: "white",
        stroke: borderColor
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "3",
        y: "3",
        width: "10",
        height: "10",
        rx: "2",
        fill: innerColor || _utils.colors["pacific-blue"].hex
      }));
    case "selected-radio":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7.5",
        stroke: borderColor || _utils.colors["pacific-blue"].hex
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "8",
        cy: "8",
        r: "5",
        fill: innerColor || _utils.colors["pacific-blue"].hex
      }));
    case "unselected-checkbox":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "1.5",
        fill: "white",
        stroke: borderColor
      }));
    case "unselected-radio":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7.5",
        stroke: borderColor
      }));
  }
}
FormIcon.propTypes = {
  /**
   * Sets color of outer border
   */
  borderColor: _propTypes.default.string,
  /**
   * Sets color of inner circle
   */
  innerColor: _propTypes.default.string,
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number
  /**
   * Sets stroke width of icon
   */
};

FormIcon.defaultProps = {
  color: "#1a202c",
  // Orca Grey 8
  height: 16,
  width: 16
};
FormIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormIcon",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "16",
        "computed": false
      },
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "16",
        "computed": false
      },
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "borderColor": {
      "description": "Sets color of outer border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "innerColor": {
      "description": "Sets color of inner circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};